/** @jsx jsx */
import { jsx, css } from '@emotion/core'

import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
`

export default function FilterIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" css={Color}>
      <g id="그룹_6909" data-name="그룹 6909" transform="translate(-6232 -9336)">
        <rect id="사각형_6584" data-name="사각형 6584" width="18" height="18" transform="translate(6232 9336)" fill="red" opacity="0"/>
        <path id="빼기_42" data-name="빼기 42" d="M370.181,190.9h-8.992a2.015,2.015,0,0,0,0-1h8.992Zm-12.866,0h-1.563v-1h1.562a2.016,2.016,0,0,0,0,1Z" transform="translate(5878.248 9149.707)" fill="#1c202b"/>
        <path id="빼기_41" data-name="빼기 41" d="M370.181,196.186h-1.6a2.017,2.017,0,0,0,.037-1h1.561v1Zm-5.429,0h-9v-1h8.96a2.005,2.005,0,0,0,.037,1Z" transform="translate(5878.248 9149.707)" fill="#1c202b"/>
        <path id="빼기_43" data-name="빼기 43" d="M370.181,200.9h-9.06a2,2,0,0,0,.131-.714,2.093,2.093,0,0,0-.02-.286h8.949Zm-12.8,0h-1.629v-1h1.52a1.944,1.944,0,0,0-.02.286,1.974,1.974,0,0,0,.131.712Z" transform="translate(5878.248 9149.707)" fill="#1c202b"/>
        <path id="패스_6321" data-name="패스 6321" d="M359.252,192.4a2,2,0,1,1,2-2A2,2,0,0,1,359.252,192.4Zm0-3a1,1,0,1,0,1,1A1,1,0,0,0,359.252,189.4Z" transform="translate(5878.248 9149.707)" fill="#1c202b"/>
        <path id="패스_6323" data-name="패스 6323" d="M366.666,197.614a2,2,0,1,1,2-2A2,2,0,0,1,366.666,197.614Zm0-3a1,1,0,1,0,1,1A1,1,0,0,0,366.666,194.614Z" transform="translate(5878.248 9149.707)" fill="#1c202b"/>
        <path id="패스_6325" data-name="패스 6325" d="M359.252,202.187a2,2,0,1,1,2-2A2,2,0,0,1,359.252,202.187Zm0-3a1,1,0,1,0,1,1A1,1,0,0,0,359.252,199.187Z" transform="translate(5878.248 9149.707)" fill="#1c202b"/>
      </g>
    </svg>
  )
}
